<template>
  <v-container class="pa-4">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card class="rounded-xl pa-4" elevation="6">
          <!-- Sarlavha -->
          <v-card-title class="justify-center pb-0">
            <div class="text-h6 font-weight-bold">Yangi nomzod qo‘shish</div>
          </v-card-title>

          <!-- Gender tanlash -->
          <v-row class="my-4" align="center" justify="center">
            <v-col cols="12" class="d-flex justify-center">
              <v-btn-toggle v-model="form.gender" class="gender-toggle" mandatory>
                <v-btn :class="form.gender === 'E' ? 'blue dark white--text' : 'grey lighten-3'" value="E">Kuyov</v-btn>
                <v-btn :class="form.gender === 'A' ? 'pink white--text' : 'grey lighten-3'" value="A">Kelin</v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>

          <!-- Form maydonlari -->
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-text-field v-model="form.age" type="number" label="Yosh" outlined dense hide-details />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="form.height" type="number" label="Bo'yi" outlined dense hide-details />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="form.weight" type="number" label="Vazni" outlined dense hide-details />
              </v-col>

              <v-col cols="12" sm="6">
                <v-select v-model="form.nationality" :items="nationalities" label="Millati" outlined dense hide-details 
                item-text="name" item-value="id"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="form.education" :items="educations" label="Ma'lumoti" outlined dense hide-details 
                item-text="name" item-value="id"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field v-model="form.profession" label="Kasbi" outlined dense hide-details />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="form.marital_status" :items="statuses" label="Oilaviy holati" outlined dense hide-details 
                item-text="name" item-value="id"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-select v-model="form.region" :items="regions" label="Viloyat" outlined dense hide-details 
                item-text="name" item-value="id"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="form.contact" label="Aloqa" outlined dense hide-details />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field v-model="form.min_age" type="number" label="Minimum" outlined dense hide-details />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="form.max_age" type="number" label="Maksimum" outlined dense hide-details />
              </v-col>

              <v-col cols="12">
                <v-textarea v-model="form.about" label="O‘zi haqida" outlined dense rows="2" hide-details />
              </v-col>
            </v-row>
          </v-form>

          <!-- Saqlash tugmasi -->
          <v-card-actions class="justify-center">
            <v-btn class="apply-btn" large @click="submit">Saqlash</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" color="success" timeout="3000">
      Nomzod muvaffaqiyatli qo‘shildi!
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AddCandidate',
  data() {
    return {
      valid: false,
      loading: false,
      snackbar: false,
      statuses: [],
      educations: [],
      nationalities: [],
      regions: [],
      form: {
        name: '',
        age: '',
        gender: 'E',
        city: '',
        education: '',
        maritalStatus: '',
        profession: '',
        photo: ''
      },
      rules: {
        required: value => !!value || 'To‘ldirish majburiy'
      }
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      try {
        await axios.post(this.$store.state.backend_url + 'api/add-candidate', this.form); // <-- API endpoint moslashtiring
        this.snackbar = true;
        this.resetForm();
        this.$router.push({ name: "my-candidates" });
      } catch (error) {
        alert('Xatolik: ' + error.message);
      } finally {
        this.loading = false;
      }
    },
    async getRef() {

      this.loading = true;
      axios.get(this.$store.state.backend_url + "api/get-profile-datas").then((res => {

        this.statuses = res.data.marital_statuses;
        this.educations = res.data.educations;
        this.nationalities = res.data.nationalities;
        this.regions = res.data.regions;
      }));
    },
    resetForm() {
      this.form = {
        name: '',
        age: '',
        city: '',
        education: '',
        maritalStatus: '',
        profession: '',
        photo: ''
      };
      this.$refs.form.reset();
    }
  },
  mounted() {
    this.getRef();
  }
};
</script>

<style scoped>
.v-card {
  background-color: #fff !important; /* oq fon */
  border-radius: 20px;
}

.gender-toggle {
  background-color: #f3f3f3;
  border-radius: 30px;
  padding: 4px;
}

.gender-toggle .v-btn {
  border-radius: 30px !important;
  text-transform: none;
  font-weight: 500;
  min-width: 90px;
  height: 40px;
  color: #333;
}
/* Apply tugma */
.apply-btn {
  width: 100%;
  border-radius: 30px;
  background: linear-gradient(45deg, #ff00cc, #3333ff);
  color: white;
  font-weight: bold;
}

</style>
